(function () {
  'use strict';

  var requestedPlan = new URLSearchParams(window.location.search).get('selling_plan');
  if (!requestedPlan) return;

  var completed = false;
  var attempts = 0;
  var observer;

  function applyDeepLink() {
    if (completed) return;

    var subscriptionRadio = document.querySelector('input[data-mode="subscription"]');
    if (!subscriptionRadio) return;

    if (!subscriptionRadio.checked) subscriptionRadio.click();

    var frequency = document.querySelector('select[data-frequency]');
    if (!frequency || frequency.disabled) return;

    var matchingPlan = Array.prototype.find.call(frequency.options, function (option) {
      return option.value === requestedPlan;
    });
    if (!matchingPlan) return;

    if (frequency.value !== requestedPlan) {
      frequency.value = requestedPlan;
      frequency.dispatchEvent(new Event('change', { bubbles: true }));
    }

    completed = true;
    if (observer) observer.disconnect();
    clearInterval(retryTimer);
  }

  observer = new MutationObserver(applyDeepLink);
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  var retryTimer = setInterval(function () {
    attempts += 1;
    applyDeepLink();
    if (attempts >= 40) {
      clearInterval(retryTimer);
      if (observer) observer.disconnect();
    }
  }, 250);
  applyDeepLink();
})();
